import UserDetailsPage, { getDefaultData } from "components/pages/UserDetailsPage";
import { BCMSDate, BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "bcms-react";
import Classes, { User, UserAccount } from "model";

/**
 * @name CaptureAddUserFilled
 * @returns {React.Component}
 * @description 
 */
export default function CaptureAddUserFilled(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "userAccount" ], BCMSDefaultModel.userAccount() )
    .submit();

    return <UserDetailsPage data={ data } />
}